export default __webpack_public_path__ + "static/media/tick-premium.5591312c.svg";